import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/advisors/AdvisorsAction";
import { useSubheader } from "../../../../../../_metronic/layout";
import { CustomSelect, redirectToPages } from "../../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { StudentsPage } from "./students/StudentsPage";

export function AdvisorEdit({
  history
}) {
  // Subheader
  const subheader = useSubheader();
  const [title, setTitle] = useState("");
  const [term, setTerm] = useState(0);
  const [teacherId, setTeacherId] = useState();
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, currentActiveTerm, teachersWithBranches } = useSelector(
    (state) => ({
      actionsLoading: state.advisors.actionsLoading,
      isSuccess: state.advisors.isSuccess,
      type: state.advisors.type,
      currentActiveTerm: state.auth.user.currentActiveTerm,
      teachersWithBranches: state.advisors.teachersWithBranches
    }),
    shallowEqual
  );

  useEffect(() => {
    setTerm(currentActiveTerm);
    dispatch(actions.getTeachersWithBranches(currentActiveTerm));
    return () => dispatch(actions.cleanRegistrationInfoIds());
  }, [currentActiveTerm, dispatch]);
  
  useEffect(() => {
    let _title = "Öğrenci Seçme";
    setTitle(_title);
    subheader.setTitle(_title);
  }, [subheader]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  return (
    <>
      <Card>
        { actionsLoading && <ModalProgressBar /> }
        <CardHeader title={title} />
        <CardBody>
          <div className="form-group row">
            <div className="col-3 mt-3">
              Dönem <span>*</span>
            </div>
            <div className="col-2">
              <input
                type="number"
                className="form-control"
                min={1}
                value={term}
                placeholder="Dönem"
                onChange={e => {
                  setTerm(parseInt(e.target.value));
                  dispatch(actions.getTeachersWithBranches(e.target.value));
                  if (teacherId) dispatch(actions.getRegistrationInfoIds(teacherId, e.target.value));
                }}
              />
            </div>
            <div className="col-2">
              <input className="form-control" value={term + 1} readOnly />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3 mt-3">
              Öğretmenler <span>*</span>
            </div>
            <div className="col-4">
              <CustomSelect
                options={teachersWithBranches}
                onChange={option => {
                  dispatch(actions.getRegistrationInfoIds(option.value, term)).then(() => setTeacherId(option.value));
                }}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      <StudentsPage
        history={history}
        teacherId={teacherId}
        term={term}
      />
    </>
  );
}